module.exports = __webpack_public_path__ + "static/media/icon_close.0881e0d9.svg";